/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_Step1_DescInputs */

const en_landing_how_step1_desc = /** @type {(inputs: Landing_How_Step1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop your existing resume or LinkedIn PDF. Alchema parses your experience, skills, and achievements instantly.`)
};

const de_landing_how_step1_desc = /** @type {(inputs: Landing_How_Step1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lade deinen bestehenden Lebenslauf oder LinkedIn-PDF hoch. Alchema erfasst sofort deine Erfahrung, Faehigkeiten und Erfolge.`)
};

const fr_landing_how_step1_desc = /** @type {(inputs: Landing_How_Step1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dépose ton CV existant ou ton PDF LinkedIn. Alchema extrait ton expérience, tes compétences et tes réalisations instantanément.`)
};

const es_landing_how_step1_desc = /** @type {(inputs: Landing_How_Step1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sube tu currículum actual o un PDF de LinkedIn. Alchema analiza tu experiencia, habilidades y logros al instante.`)
};

const it_landing_how_step1_desc = /** @type {(inputs: Landing_How_Step1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carica il tuo curriculum o il PDF di LinkedIn. Alchema analizza esperienze, competenze e risultati in un istante.`)
};

const nl_landing_how_step1_desc = /** @type {(inputs: Landing_How_Step1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload je bestaande CV of LinkedIn-PDF. Alchema analyseert direct je ervaring, vaardigheden en prestaties.`)
};

const pl_landing_how_step1_desc = /** @type {(inputs: Landing_How_Step1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wrzuć swoje istniejące CV lub PDF z LinkedIn. Alchema błyskawicznie wyodrębni Twoje doświadczenie, umiejętności i osiągnięcia.`)
};

const fi_landing_how_step1_desc = /** @type {(inputs: Landing_How_Step1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pudota olemassa oleva ansioluettelosi tai LinkedIn-PDF. Alchema jäsentää kokemuksesi, taitosi ja saavutuksesi hetkessä.`)
};

const da_landing_how_step1_desc = /** @type {(inputs: Landing_How_Step1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload dit eksisterende CV eller LinkedIn PDF. Alchema analyserer din erfaring, færdigheder og resultater med det samme.`)
};

const sv_landing_how_step1_desc = /** @type {(inputs: Landing_How_Step1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Släpp in ditt befintliga CV eller LinkedIn-PDF. Alchema tolkar din erfarenhet, dina färdigheter och prestationer direkt.`)
};

/**
* | output |
* | --- |
* | "Drop your existing resume or LinkedIn PDF. Alchema parses your experience, skills, and achievements instantly." |
*
* @param {Landing_How_Step1_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_how_step1_desc = /** @type {((inputs?: Landing_How_Step1_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_Step1_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_how_step1_desc(inputs)
	if (locale === "fr") return fr_landing_how_step1_desc(inputs)
	if (locale === "es") return es_landing_how_step1_desc(inputs)
	if (locale === "it") return it_landing_how_step1_desc(inputs)
	if (locale === "nl") return nl_landing_how_step1_desc(inputs)
	if (locale === "pl") return pl_landing_how_step1_desc(inputs)
	if (locale === "fi") return fi_landing_how_step1_desc(inputs)
	if (locale === "da") return da_landing_how_step1_desc(inputs)
	if (locale === "sv") return sv_landing_how_step1_desc(inputs)
	return en_landing_how_step1_desc(inputs)
});